import { useQuery } from '@tanstack/react-query';
import { IStates } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';

export const getAllStates = async () => {
  const res = await apiManager.get<IStates>("/states/getStates");
  return res;
};

export const useGetAllStates = () =>
  useQuery({
    queryKey: ["get_all_states"],
    queryFn: async (): Promise<IStates> => {
      const res = await apiClient.get("/states/getStates");
      return res.data;
    },
  });